import {connect} from "../../JavaScript/Utils";

class BackToTop {

  /**
   * @var {HTMLElement}
   */
  element;

  windowYOffset = 200;

  constructor(element, autoHide = true) {
    this.element = element;
    this.addClickListener();

    if (autoHide) {
      this.handleAutoHide()
    }
  }

  addClickListener() {
    if (this.element instanceof HTMLElement) {
      this.element.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto"
        });
      });
    }
  }

  handleAutoHide() {
    const validate = () => {
      if (window.pageYOffset < this.windowYOffset) {
        this.element.style.opacity = 0;
        this.element.style.pointerEvents = 'none';
      } else {
        this.element.style.opacity = 1;
        this.element.style.pointerEvents = null;
      }
    }
    validate();
    window.addEventListener('scroll', validate);
  }

}

connect('.backtotop', BackToTop);
